import {
    GET_LEAD_PROFILE_PHOTOS_REQUEST,
    GET_LEAD_PROFILE_PHOTOS_REQUEST_SUCCESS,
    GET_LEAD_PROFILE_PHOTOS_REQUEST_FAILURE,
    UPLOAD_LEAD_PROFILE_PHOTO_REQUEST,
    UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS,
    UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_FAILURE,
    DELETE_LEAD_PROFILE_PHOTO_REQUEST,
    DELETE_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS,
    DELETE_LEAD_PROFILE_PHOTO_REQUEST_FAILURE,
} from '../constants/lead_profile_photos.constants';

export const getLeadProfilePhotosRequest = _id => ({
    type: GET_LEAD_PROFILE_PHOTOS_REQUEST, _id,
});

export const getLeadProfilePhotosRequestSuccess = payload => ({
    type: GET_LEAD_PROFILE_PHOTOS_REQUEST_SUCCESS, payload,
});

export const getLeadProfilePhotosRequestFailure = error => ({
    type: GET_LEAD_PROFILE_PHOTOS_REQUEST_FAILURE, error,
});

export const uploadLeadProfileRequest = (_id, kind, picture, blemish_report_question) => ({
    type: UPLOAD_LEAD_PROFILE_PHOTO_REQUEST, _id, kind, picture, blemish_report_question,
});

export const uploadLeadProfileRequestSuccess = payload => ({
    type: UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS, payload,
});

export const uploadLeadProfileRequestFailure = error => ({
    type: UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_FAILURE, error,
});

export const deleteLeadProfilePhotosRequest = (_id, photos, photo_index) => ({
    type: DELETE_LEAD_PROFILE_PHOTO_REQUEST, _id, photos, photo_index,
});

export const deleteLeadProfileRequestSuccess = payload => ({
    type: DELETE_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS, payload,
});

export const deleteLeadProfileRequestFailure = error => ({
    type: DELETE_LEAD_PROFILE_PHOTO_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/lead_profile_photos.actions.js